class FinanceMyWidgetLoader {
  constructor(params) {
    const { root, onAuthChange, ...props } = params;

    this.props = props;

    this.init = new Promise((resolve) => {
      this.resolveInit = resolve;
    });

    this.#init({
      root,
      onAuthChange,
      ...props,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async #loadModule(url) {
    if (window.twmy.loadedScripts.includes(url)) {
      return window.FinanceMyWidgetLibrary;
    }

    const module = await import(url);
    window.twmy.loadedScripts.push(url);

    return module;
  }

  async #init(params) {
    const filenameHash = process.env.APP_BUILD_DATE;
    const mainFile = filenameHash ? `main.${filenameHash}.js` : 'main.js';
    const mainUrl = `${process.env.APP_DEPLOY_URL}/${mainFile}`;
    const moduleReadyEventName = 'twmy:module:ready';

    try {
      // Якщо ModalWrapper вже існує — лише додаємо колбеки
      if (window.twmy.app) {
        const { app } = window.twmy;

        // Додати слухача
        if (params.onAuthChange) app.onAuthChange(params.onAuthChange);

        // Якщо інший клієнт хоче одразу відкрити — викликаємо open()
        if (params.isOpen) app.open();

        this.resolveInit(app);

        return;
      }

      // Якщо віджет неготовий, але модуль почав вже ініціалізуватися
      if (window.twmy.isReady) {
        const onModuleReady = () => {
          this.#init(params);
          window.removeEventListener(moduleReadyEventName, onModuleReady);
        };
        window.addEventListener(moduleReadyEventName, onModuleReady);

        return;
      }

      // Перший інстанс — створюємо і рендеримо
      window.twmy.isReady = true;
      const { ModalWrapper } = await this.#loadModule(mainUrl);
      const app = new ModalWrapper(params.root, params);
      app.render();

      window.twmy.app = app;

      // Чекаючі клієнти отримують подію готовності ініціалізації
      window.dispatchEvent(new CustomEvent(moduleReadyEventName));

      this.resolveInit(app);
    } catch (error) {
      console.debug('Failed to load FinanceMyWidgetLibrary:', error);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  destroy() {
    window.twmy.consumers -= 1;

    if (window.twmy.consumers === 0) {
      window.twmy.app?.destroy();
      window.twmy.app = null;
    }
  }
}

function initFinanceMyWidgetLoader() {
  const queue = (window.twmy || {}).q || [];

  window.twmy = (params) => {
    const item = new FinanceMyWidgetLoader(params);
    window.twmy.consumers += 1;

    return item;
  };

  window.twmy.isReady = false;
  window.twmy.loadedScripts = [];
  window.twmy.app = null;
  window.twmy.consumers = 0;
  window.twmy.q = queue;

  queue.forEach(({ params, resolveInit }) => {
    const item = window.twmy(params);
    item.init.then(resolveInit);
  });
}

if (document.readyState !== 'loading') {
  initFinanceMyWidgetLoader();
} else {
  document.addEventListener('DOMContentLoaded', initFinanceMyWidgetLoader);
}
